module.exports = __webpack_public_path__ + "img/labmem_text_btnnext_en.57e691ca.png";